import './Patient.scss';
import React, { useEffect, useState, useContext, useCallback } from "react";
import InputMask from "react-input-mask";
import moment from "moment";
// Constants
import label from "../../../../../../assets/i18n/en.json";
import States from "../../../../../common/constants/states.constant";

// Templates
import AccordionTemplate from "../../../../templates/components/AccordionTemplate";
import HPTSelect from "../../../../templates/components/HPTSelect";
import { store } from '../../../../../context/StateProvider'
import FormValidatorService from "../../../../../services/validator/form-validator.service";
import PatientFormConfig from "./patient-form-config";
import toast from "react-hot-toast";
import LeadSourceService from "../../../../../services/api/lead-source.service";
import CommonService from "../../../../../services/api/common.service";

import { 
  useGetPracticePatientTypes, 
  useGetPracticePatientTags
} from "../../../../../services/cache/CacheService";
import ModalBox from '../../../../templates/components/ModalBox';

const PatientForm = (props) => {
  const globalStateAndDispatch = useContext(store)
  const contextState = globalStateAndDispatch.state
  //Form Variables
  // Other Variables
  const required = ['firstName', 'lastName', 'dob', 'patientTypeId']

  const { submitLabel, submitHandler, initialData } = props;
  const [formData, setFormData] = useState(initialData);
  const [ssnShowEye, setSsnShowEye] = useState(false);
  const [errors, setErrors] = useState({})
  const [isLoader_Type, setIsLoader_Type] = useState();
  const [isLoader_Tag, setIsLoader_Tag] = useState(false);
  const [isOptIn, setIsOptIn] = useState(props?.initialData?.isOptIn || false);
  const [isOptInOld, setIsOptInOld] = useState(props?.initialData?.isOptIn || false);
  const patientTypes = useGetPracticePatientTypes()
  const tagsList = useGetPracticePatientTags()
  const [allUserList, setAllUserList] = useState([])
  const [isLoader_User, setIsLoader_User] = useState(false)
  const [userType, setUserType] = useState(props.initialData.referredByUserTypeId ? props.initialData.referredByUserTypeId.toString() :"0")
  const [leadSourceList, setLeadSourceList] = useState([])
  const [isLoader_LeadSource, setIsLoader_LeadSource] = useState(false)
  const preferredPracticeLocationList = globalStateAndDispatch.state.practiceLocations
  const [showConfirm, setShowConfirm] = useState(false)

  const handleIsOptIn = () => {
    setIsOptIn(!isOptIn);
  };

  const handleClearForm = () => {
    setFormData({ firstName: '', lastName: '', ssn: '', email: '', phone: '', address: { addressLine1: '', addressLine2: '', city: '', state: '', postalCode: '', country: '' } });
  };

  // mount onInit
  useEffect(() => {
    // insuranceLookup();
    leadSourceLookup();
  }, []);

const userLookup = () => {
    setIsLoader_User(true)
    let reqObj = { UserType: +userType, IsActive: 1 }
    CommonService.allUserLookup(reqObj)
      .then((response) => {
        setAllUserList(response.data)
      })
      .catch(error => {
        console.log(error)
      }).finally(() => {
        setIsLoader_User(false)
      })
  }
  const leadSourceLookup = () => {
    setIsLoader_LeadSource(true)
    LeadSourceService.getAllLeadSource()
      .then((response) => {
        setLeadSourceList(response.data)
      })
      .catch(error => {
        console.log(error)
      }).finally(() => {
        setIsLoader_LeadSource(false)
      })
  }

  const tagsHandler = (e) => {
    let newStateObject = { ...formData };
    if (newStateObject.patientTags) {
      newStateObject.patientTags.push({ patientTagId: e.patientTagId, name: e.name })
    } else {
      newStateObject['patientTags'] = [{ patientTagId: e.patientTagId, name: e.name }];
    }
    return setFormData(newStateObject);
  }

  const removeTag = (index) => {
    let newStateObject = { ...formData };
    newStateObject.patientTags.splice(index, 1);
    setFormData(newStateObject);
  }

  // function for input change
  const inputChange = (e) => {
    let newStateObject = { ...formData };
    newStateObject[e.target.name] = e.target.value;
    setErrors(FormValidatorService.setErrors(e, errors, PatientFormConfig.config))
    return setFormData(newStateObject);
  };

  // function for address change
  const addressChange = (e) => {
    let newStateObject = { ...formData };
    newStateObject.address[e.target.name] = e.target.value;
    setErrors(FormValidatorService.setErrors(e, errors, PatientFormConfig.config))
    return setFormData(newStateObject);
  };
  
  // useEffect(() => {
  //   if (formData.secondaryIns) {
  //     let newStateObject = { ...formData };
  //     newStateObject.insuranceDetails.push({ address: {} });
  //     return setFormData(newStateObject);
  //   }
  // }, [formData.secondaryIns]);

  useEffect(() => {
    if (formData.phone === "") {
      setIsOptIn(false)
      inputChange({
        target: {
          value: false,
          name: "isOptIn",
        },
      });
    }
  }, [formData.phone]);
  useEffect(() => {
    if (props.isEdit) {
      if (formData.isOptIn !== isOptInOld) {
        inputChange({
          target: { value: true, name: "isOptInChanged" }
        })
      } else {
        inputChange({
          target: { value: false, name: "isOptInChanged" }
        })
      }
    }
  }, [formData.isOptIn]);
  
  useEffect(() => {
    //resetting the value
      inputChange({
        target: {
          name: 'referredByUserTypeId', value: userType
        }
      })
    userLookup()
  }, [userType])

  return (
    <>
      {isLoader_Type && isLoader_Tag && (
        <div className="ui active dimmer">
          <div className="ui indeterminate text loader">{label.common.loading}</div>
        </div>
      )}
        <AccordionTemplate id="patientForm" accordionId="patientForm">
          {/* Basic Details Form Portion */}
          {/* Todo: add masking, error messages, and address validation */}
          <div title={label.patient.add.basicDetails.toString()}>
            <div className=" row d-flex align-items-start">
              <div className="col-md-6 col-12 required field">
                <label> {label.patient.add.firstName}</label>
                <input
                  placeholder="First Name"
                  type="text"
                  name="firstName"
                  value={formData.firstName}
                  onChange={(e) => {
                    e.preventDefault();
                    inputChange(e);
                  }}
                  required
                />
                <span className="error-message">{errors.firstName}</span>
              </div>

              <div className="col-md-6 col-12 required field">
                <label> {label.patient.add.lastName}</label>
                <input
                  placeholder="Last Name"
                  type="text"
                  name="lastName"
                  value={formData.lastName}
                  onChange={(e) => {
                    e.preventDefault();
                    inputChange(e);
                  }}
                  required
                />
                <span className="error-message">{errors.lastName}</span>
              </div>
              {/* Validate birthday input vales */}
              <div className="col-md-6 col-12 required field">
                <label>{label.patient.add.dob}</label>
                <div className="ui">
                  <input
                    onChange={(e) => {
                      e.preventDefault();
                      inputChange(e);
                    }}
                    placeholder="MM/DD/YYYY"
                    type="date"
                    // pattern="\d{4}-\d{2}-\d{2}"
                    min="1900-01-01"
                    max={moment().format("YYYY-MM-DD")}
                    name="dob"
                    value={formData.dob}
                    required
                  />
                </div>
                <span className="error-message">{errors.dob}</span>
              </div>

              {/* Have masked with stars */}
              <div className="col-md-6 col-12 field">
                <label> {label.patient.add.ssn}</label>
                <div className="ui right icon input w-100">
                  <input
                    placeholder="SSN"
                    type={ssnShowEye ? "text" : "password"}
                    // type="text"
                    alwaysShowMask={false}
                    // maskChar="*"
                    className="form-control"
                    name="ssn"
                    minLength="9"
                    maxLength="9"
                    unmask={true}
                    value={formData.ssn}
                    onChange={(e) => {
                      e.preventDefault();
                      inputChange(e);
                    }}
                  />
                  <a className="ui icon view-pw">
                    <i
                      className={
                        ssnShowEye
                          ? "eye icon text-decoration-none"
                          : "low vision icon text-decoration-none"
                      }
                      onClick={(e) => {
                        e.preventDefault();
                        ssnShowEye ? setSsnShowEye(false) : setSsnShowEye(true);
                      }}
                    ></i>
                  </a>
                </div>
                <span className="error-message">{errors.ssn}</span>
              </div>
              {contextState.permissions.patientContactInfo && <>
              <div className="col-md-6 col-12 field">
                <label> {label.patient.add.phone}</label>
                <InputMask
                  placeholder="Phone"
                  type="text"
                  name="phone"
                  mask="(999) 999-9999"
                  unmask={true}
                  onUnmask
                  value={formData.phone}
                  onChange={(e) => {
                    e.preventDefault();
                    inputChange(e);
                  }}
                  editable
                />
                <span className="error-message">{errors.phone}</span>
              </div>
              <div
                className="col-md-6 col-12 field"
              >
                <label> {label.patient.add.email}</label>
                <input
                  placeholder="Email"
                  type="email"
                  name="email"
                  className="form-control"
                  value={formData.email}
                  onChange={(e) => {
                    e.preventDefault();
                    inputChange(e);
                  }}
                />
                <span className="error-message">{errors.email}</span>
              </div>
              </>}
              <div
                className="col-md-6 col-12 field"
              >
                <label>Lead Source</label>
                <HPTSelect
                  className="react-select-container"
                  classNamePrefix="react-select"
                  options={leadSourceList}
                  name="leadSourceId"
                  value={leadSourceList && leadSourceList.find(obj => obj.id === formData.leadSourceId)? leadSourceList.find(obj => obj.id === formData.leadSourceId) : ""}
                  onChange={e => {
                    inputChange({
                      target:
                        { value: e.id, name: 'leadSourceId' }
                    })
                  }}
                  getOptionLabel={(option) => option.leadSource}
                  getOptionValue={(option) => option.id}
                  // menuPortalTarget={document.body}
                  // styles={{menuPortal: base => ({ ...base, zIndex: 9999 }),}}
                />
                <span className="error-message">{errors?.leadSourceId}</span>
              </div>
              <div
                className="col-md-6 col-12 field required"
              >
                <label> {label.patient.add.patientType}</label>
                <HPTSelect
                  className="react-select-container"
                  classNamePrefix="react-select"
                  options={patientTypes}
                  name="patientTypeId"
                  value={patientTypes && patientTypes.find(obj => obj.practicePatientTypeId === formData.patientTypeId) ? patientTypes.find(obj => obj.practicePatientTypeId === formData.patientTypeId):""}
                  onChange={e => {
                    inputChange({
                      target:
                        { value: e.practicePatientTypeId, name: 'patientTypeId' }
                    })
                  }}
                  getOptionLabel={(option) => option.patientType}
                  getOptionValue={(option) => option.practicePatientTypeId}
                  // menuPortalTarget={document.body}
                  // styles={{menuPortal: base => ({ ...base, zIndex: 9999 }),}}
                />
                <span className="error-message">{errors?.patientTypeId}</span>
              </div>
            <div
              className="col-md-6 col-12 field"
            >
              <div className="row d-flex">
              <label>Referred By:</label>
              <div className="col-auto">
              <div className="form-check form-check-inline">
                  <input className="form-check-input" type="radio" name="referredByUserTypeId" id="inlineRadio1" checked={userType.toString() === "0"} onChange={e => { 
                    inputChange({
                      target:
                        { value: null, name: 'referredById' }
                    })
                    setUserType("0") }} value="0" />
                  <span className="form-check-label" for="inlineRadio1">Patient</span>
                </div>
              </div>
                
                <div className="col-auto">
                <div className="form-check form-check-inline">
                  <input className="form-check-input" type="radio" name="referredByUserTypeId" id="inlineRadio2" checked={userType.toString() === "1"} onChange={e => { 
                    inputChange({
                      target:
                        { value: null, name: 'referredById' }
                    })
                    setUserType("1") }} value="1" />
                  <span className="form-check-label" for="inlineRadio2">Associate</span>
                </div>
                </div>
              </div>
              
            </div>
            <div
              className="col-md-6 col-12 field"
            >
              <label>Select Referred User</label>
              <HPTSelect
                className="react-select-container"
                classNamePrefix="react-select"
                options={allUserList}
                name="referredById"
                value={allUserList && formData.referredById ? allUserList.find(obj => obj.id === formData.referredById) : null}
                onChange={e => {
                  inputChange({
                    target:
                      { value: e.id, name: 'referredById' }
                  })
                }}
                getOptionLabel={(option) => `${option.contact?.name?.firstName} ${option.contact?.name?.lastName}`}
                getOptionValue={(option) => option.id}
                // menuPortalTarget={document.body}
                // styles={{menuPortal: base => ({ ...base, zIndex: 9999 }),}}
              />
              <span className="error-message">{errors?.referredById}</span>
            </div>
              <div className="col-md-6 col-12">
                <div className="field">
                  <label>Text Messaged Notifications</label>
                  <div className="form-check">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      name="isOptIn"
                      checked={isOptIn}
                      disabled={!(formData.phone && !errors?.phone)}
                      onChange={(e) => {
                        handleIsOptIn(e.target.checked);
                        inputChange({
                          target: {
                            value: !isOptIn,
                            name: "isOptIn",
                          },
                        });
                      }}
                    />
                    <label className="form-check-label">
                      {isOptIn ? 'Opted-In to' : 'Opted-Out of'} text messages
                    </label>
                  </div>
                </div>
              </div>
              
              {/* <div
                className="col-md-6 col-12 field"
              >
                <label>Preferred Practice Location</label>
                <HPTSelect
                  className="react-select-container"
                  classNamePrefix="react-select"
                  placeholder="Select Location"
                  options={preferredPracticeLocationList}
                  loadingMessage="Locations are loading..."
                  name="preferredPracticeLocationId"
                  value={preferredPracticeLocationList && preferredPracticeLocationList.find(obj => obj.practiceLocationId === formData.preferredPracticeLocationId)? preferredPracticeLocationList.find(obj => obj.practiceLocationId === formData.preferredPracticeLocationId) : ""}
                  onChange={e => {
                    inputChange({
                      target:
                        { value: e.practiceLocationId, name: 'preferredPracticeLocationId' }
                    })
                  }}
                  getOptionLabel={(option) => option.practiceLocation}
                  getOptionValue={(option) => option.practiceLocationId}
                  // menuPortalTarget={document.body}
                  // styles={{menuPortal: base => ({ ...base, zIndex: 9999 }),}}
                />
                <span className="error-message">{errors?.preferredPracticeLocationId}</span>
              </div> */}
          {/*
          * Renders a warning message based on the presence of email and phone number in the form data.
          * 
          * If both email and phone number are empty, it warns that the patient will not be able to log in to the patient portal and will not receive transaction updates.
          * If only phone number is empty, it warns that the patient will not be able to log in using OTP and will not receive transaction updates via phone.
          * If only email is empty, it warns that the patient will not be able to log in using OTP and will not receive transaction updates via email.
          */}
            {(!formData.email || formData.email === "") && (!formData.phone || formData.phone === "")
              ? <span style={{ color: "red" }}>*Please provide email or phone number to enable patient portal login and transaction updates.</span>
              : formData.email && formData.email !== "" && (!formData.phone || formData.phone === "")
                ? <span style={{ color: "red" }}>*Please provide a phone number to enable OTP login and transaction updates via phone.</span>
                : (!formData.email || formData.email === "") && formData.phone && formData.phone !== ""
                  ? <span style={{ color: "red" }}>*Please provide an email to enable OTP login and transaction updates via email.</span>
                  : null}
            </div>
          </div>
          {/* Address Details Form Portion */}
          <div title={label.patient.add.addressDetails.toString()} hide={!contextState.permissions.patientContactInfo}> 
            <div className="row d-flex">
              <div className="field">
                <label> {label.patient.add.addressLine1}</label>
                <input
                  placeholder="Address Line 1"
                  type="text"
                  name="addressLine1"
                  value={formData.address?.addressLine1}
                  onChange={(e) => {
                    e.preventDefault();
                    addressChange(e);
                  }}
                />
                <span className="error-message">{errors.addressLine1}</span>
              </div>
              <div className="field">
                <label> {label.patient.add.addressLine2}</label>
                <input
                  placeholder="Address Line 2"
                  type="text"
                  name="addressLine2"
                  value={formData.address?.addressLine2}
                  onChange={(e) => {
                    e.preventDefault();
                    addressChange(e);
                  }}
                />
                <span className="error-message">{errors.addressLine2}</span>
              </div>
              <div className="field col-12">
                <label> {label.patient.add.city}</label>
                <input
                  placeholder="City"
                  type="text"
                  name="city"
                  value={formData.address?.city}
                  onChange={(e) => {
                    e.preventDefault();
                    addressChange(e);
                  }}
                />
                {/* // <span>{addPatientFormErrors.City}</span> */}
              </div>
              <div className="field col-md-4 col-12">
                <label> {label.patient.add.country}</label>
                {/* <HPTSelect
                    className="selection"
                    options={Countries}
                    name="country"
                    value="USA"
                    onChange={(e) => {
                      addressChange({
                        target: {
                          value: e.countryId,
                          name: "country",
                        },
                      });
                    }}
                    getOptionLabel={(option) => option.name}
                    getOptionValue={(option) => option.countryId}
                    disable
                  ></Select> */}
                <input
                  name="country"
                  placeholder="USA"
                  type="text"
                  value="USA"
                  disable
                />
                {/* // <span>{addPatientFormErrors.Country}</span> */}
              </div>
              <div className="field col-md-4 col-12">
                <label>{label.patient.add.state}</label>
                <HPTSelect
                  className="react-select-container"
                  classNamePrefix="react-select"
                  options={
                    formData.address?.country === "CANADA"
                      ? States[2]
                      : States[1]
                  }
                  name="state"
                  value={
                    formData.address?.country === "CANADA"
                      ? (States[2].find((obj) => obj.abbreviation === formData.address?.state) ? States[2].find((obj) =>obj.abbreviation === formData.address?.state) : "")
                      : (States[1].find((obj) => obj.abbreviation === formData.address?.state) ? States[1].find((obj) => obj.abbreviation === formData.address?.state) : "" )
                  }
                  onChange={(e) => {
                    addressChange({
                      target: {
                        value: e.abbreviation,
                        name: "state",
                      },
                    });
                  }}
                  getOptionLabel={(option) => option.name}
                  getOptionValue={(option) => option.abbreviation}
                />
                <span className="error-message">{errors.state}</span>
              </div>
              <div className="field col-md-4 col-12">
                <label> {label.patient.add.postalCode}</label>
                <input
                  placeholder="Postal Code"
                  type="text"
                  name="postalCode"
                  value={formData.address?.postalCode}
                  onChange={(e) => {
                    e.preventDefault();
                    addressChange(e);
                  }}
                />
                <span className="error-message">{errors.postalCode}</span>
              </div>
            </div>
          </div>
          {/* Insurance Details Form Portion */}
          {/* <div title={label.patient.add.insuranceDetails.toString()}>
            <div className="">
              <div className="required field">
                <label for="HasInsurance">
                  {label.patient.add.hasInsurance}
                </label>
                <div className="fields ms-2 my-3">
                  <div className="ui radio checkbox">
                    <input
                      type="radio"
                      className="form-check-input"
                      name="isInsured"
                      value={formData.isInsured}
                      onInputCapture={(e) => {
                        e.preventDefault();
                        inputChange({
                          target: {
                            value: true,
                            name: "isInsured",
                          },
                        });
                        setStateOfFirstInsurance(true);
                      }}
                    />
                    <label className="form-check-label">
                      {label.patient.add.yes}
                    </label>
                  </div>
                  <div className="ui radio checkbox ms-5">
                    <input
                      type="radio"
                      className="form-check-input"
                      name="isInsured"
                      value={!formData.isInsured}
                      onInputCapture={(e) => {
                        e.preventDefault();
                        setStateOfFirstInsurance(false);
                        inputChange({
                          target: {
                            value: false,
                            name: "isInsured",
                          },
                        });
                      }}
                    />
                    <label className="form-check-label">
                      {label.patient.add.no}
                    </label>
                  </div>
                </div>
                
              </div>

              {
                (stateOfFirstInsurance,
                formData.insuranceDetails && (
                  <div>
                    <TabsTemplate style="pills">
                      <div title="Primary Insurance">
                        <div
                          className="tab-pane fade show active ui bottom attached"
                          id="primary"
                          role="tabpanel"
                          aria-labelledby="primary-tab"
                        >
                          <div className="two fields">
                            <div className="required field">
                              <label>
                                {label.patient.add.insurancePartner}
                              </label>
                              <HPTSelect
                                className="selection"
                                options={insurancePartnerList}
                                name="insurancePartnerId"
                                getOptionLabel={(option) => option.name}
                                getOptionValue={(option) => option.id}
                                searchable={true}
                                value={
                                  formData.insuranceDetails &&
                                  insurancePartnerList.find(
                                    (obj) =>
                                      obj.id ===
                                      formData?.insuranceDetails[0]
                                        ?.insurancePartnerId
                                  )
                                }
                                onChange={(e) =>
                                  insuranceDetailsChange({
                                    target: {
                                      value: e.id,
                                      name: "insurancePartnerId",
                                    },
                                  })
                                }
                              />
                            </div>
                            <div className="required field">
                              <label>{label.patient.add.policyNo}</label>
                              <input
                                type="text"
                                placeholder={label.patient.add.policyNo}
                                name="policyNo"
                                value={formData?.insuranceDetails[0]?.policyNo}
                                onChange={(e) => {
                                  e.preventDefault();
                                  insuranceDetailsChange(e);
                                }}
                              />
                            </div>
                          </div>
                          <div className="two fields">
                            <div className="field">
                              <label>{label.patient.add.groupNo}</label>
                              <input
                                type="text"
                                placeholder={label.patient.add.groupNo}
                                name="groupNo"
                                value={formData?.insuranceDetails[0]?.GroupNo}
                                onChange={(e) => {
                                  e.preventDefault();
                                  insuranceDetailsChange(e);
                                }}
                              />
                            </div>
                            <div className="field">
                              <label>{label.patient.add.binNo}</label>
                              <input
                                type="text"
                                placeholder={label.patient.add.binNo}
                                name="binNo"
                                value={formData?.insuranceDetails[0]?.binNo}
                                onChange={(e) => {
                                  e.preventDefault();
                                  insuranceDetailsChange(e);
                                }}
                              />
                            </div>
                          </div>
                                                    <div className="two fields">
                            <div className="required field">
                              <label>{label.patient.add.relation}</label>
                              <HPTSelect
                                options={PatientEnum.RelationEnum}
                                name="relation"
                                getOptionLabel={(option) => option.type}
                                getOptionValue={(option) => option.value}
                                searchable={true}
                                value={PatientEnum.RelationEnum.find(
                                  (obj) => obj.id === formData.relation
                                )}
                                onChange={(e) =>
                                  insuranceDetailsChange({
                                    target: {
                                      value: e.value,
                                      name: "relation",
                                    },
                                  })
                                }
                              />
                            </div>
                          </div>
                          <div className="two fields">
                            <div className="required field">
                              <label> {label.patient.add.firstName}</label>
                              <input
                                placeholder="Last Name"
                                type="text"
                                name="firstName"
                                value={formData?.insuranceDetails[0]?.firstName}
                                onChange={(e) => {
                                  e.preventDefault();
                                  insuranceDetailsChange(e);
                                }}
                              />
                            </div>
                            <div className="required field">
                              <label> {label.patient.add.lastName}</label>
                              <input
                                placeholder="First Name"
                                type="text"
                                name="lastName"
                                value={formData?.insuranceDetails[0]?.lastName}
                                onChange={(e) => {
                                  e.preventDefault();
                                  insuranceDetailsChange(e);
                                }}
                              />
                            </div>
                          </div>
                          <div className="two fields">
                            <div className="required field">
                              <label> {label.patient.add.phone}</label>
                              <input
                                placeholder="Phone"
                                type="text"
                                mask="000-000-0000"
                                unmask={true}
                                validation="false"
                                name="phone"
                                value={formData?.insuranceDetails[0]?.phone}
                                onChange={(e) => {
                                  e.preventDefault();
                                  insuranceDetailsChange(e);
                                }}
                              />
                            </div>
                            <div className="field">
                              <label> {label.patient.add.email}</label>
                              <input
                                placeholder="Email"
                                type="text"
                                name="email"
                                value={formData?.insuranceDetails[0]?.email}
                                onChange={(e) => {
                                  e.preventDefault();
                                  insuranceDetailsChange(e);
                                }}
                              />
                            </div>
                          </div>
                          <div className="field ui checkbox">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              name="sameAsPatientAddress"
                              value={
                                formData?.insuranceDetails[0]
                                  ?.samePatientAddress === "true"
                                  ? true
                                  : false
                              }
                              onInputCapture={(e) => {
                                let newData = e;
                                newData.target.value = newData.target.checked;
                                console.log(e);
                                e.preventDefault();
                                insuranceDetailsChange(newData);
                                setSameAddress(true); 
                              }}
                            />
                            <label className="form-check-label">
                              {label.patient.add.sameAsInsurerAddress}
                            </label>
                          </div>
                          <div className="field">
                            <label>{label.patient.add.addressLine1}</label>
                            <input
                              placeholder="Address Line 1"
                              type="text"
                              name="insureAddressLine1"
                              value={
                                formData?.insuranceDetails[0]
                                  ?.insureAddressLine1
                              }
                              onChange={(e) => {
                                e.preventDefault();
                                insuranceAddressDetailsChange(e);
                              }}
                              disabled={
                                formData?.insuranceDetails[0]
                                  ?.sameAsPatientAddress === "true"
                                  ? true
                                  : null
                              }
                            />
                          </div>
                          <div className="field">
                            <label>{label.patient.add.addressLine2}</label>
                            <input
                              placeholder="Address Line 2"
                              type="text"
                              name="insureAddressLine2"
                              value={
                                formData?.insuranceDetails[0]
                                  ?.insureAddressLine2
                              }
                              onChange={(e) => {
                                e.preventDefault();
                                insuranceAddressDetailsChange(e);
                              }}
                              disabled={
                                formData?.insuranceDetails[0]
                                  ?.sameAsPatientAddress === "true"
                                  ? true
                                  : null
                              }
                            />
                          </div>
                          <div className="two fields">
                            <div className="field">
                              <label>{label.patient.add.city}</label>
                              <input
                                placeholder="City"
                                type="text"
                                name="insureCity"
                                value={
                                  formData?.insuranceDetails[0]?.insureCity
                                }
                                onChange={(e) => {
                                  e.preventDefault();
                                  insuranceAddressDetailsChange(e);
                                }}
                                disabled={
                                  formData?.insuranceDetails[0]
                                    ?.sameAsPatientAddress === "true"
                                    ? true
                                    : null
                                }
                              />
                            </div>
                            <div className="field">
                              <label>{label.patient.add.country}</label>
                              <HPTSelect
                                options={Countries}
                                name="country"
                                value={Countries.find(
                                  (obj) =>
                                    obj.name ===
                                    formData?.insuranceDetails[0]?.insureCountry
                                )}
                                onChange={(e) => {
                                  insuranceAddressDetailsChange({
                                    target: {
                                      value: e.name,
                                      name: "insureCountry",
                                    },
                                  });
                                }}
                                getOptionLabel={(option) => option.name}
                                getOptionValue={(option) => option.countryId}
                                disabled={
                                  formData?.insuranceDetails[0]
                                    ?.sameAsPatientAddress === "true"
                                    ? true
                                    : null
                                }
                              >
                                <div className="ui icon search input">
                                  <i className="search icon"></i>
                                </div>
                                <div className="divider"></div>
                              </Select>
                            </div>
                          </div>
                          <div className="two fields">
                            <div className="field">
                              <label>{label.patient.add.state}</label>
                              <HPTSelect
                                className="selection"
                                options={
                                  formData?.insuranceDetails[0]
                                    ?.insureCountry === "CANADA"
                                    ? States[2]
                                    : States[1]
                                }
                                name="insureState"
                                value={
                                  formData?.insuranceDetails[0]
                                    ?.insureCountry === "CANADA"
                                    ? States[2].find(
                                        (obj) =>
                                          obj.abbreviation ===
                                          formData?.insuranceDetails[0]
                                            ?.insureState
                                      )
                                    : States[1].find(
                                        (obj) =>
                                          obj.abbreviation ===
                                          formData?.insuranceDetails[0]
                                            ?.insureState
                                      )
                                }
                                onChange={(e) => {
                                  insuranceAddressDetailsChange({
                                    target: {
                                      value: e.abbreviation,
                                      name: "state",
                                    },
                                  });
                                }}
                                getOptionLabel={(option) => option.name}
                                getOptionValue={(option) => option.abbreviation}
                                disabled={
                                  formData?.insuranceDetails[0]
                                    ?.sameAsPatientAddress === "true"
                                    ? true
                                    : null
                                }
                              >
                                <div className="ui icon search input">
                                  <i className="search icon"></i>
                                </div>
                                <div className="divider"></div>
                              </Select>
                            </div>
                            <div className="field">
                              <label> {label.patient.add.postalCode}</label>
                              <input
                                placeholder="Postal (Zip) Code"
                                mask="00000-0000"
                                unmask={true}
                                validation="false"
                                type="text"
                                name="insurePostalCode"
                                value={
                                  formData?.insuranceDetails[0]
                                    ?.insurePostalCode
                                }
                                onChange={(e) => {
                                  e.preventDefault();
                                  insuranceAddressDetailsChange(e);
                                }}
                                disabled={
                                  formData?.insuranceDetails[0]
                                    ?.sameAsPatientAddress === "true"
                                    ? true
                                    : null
                                }
                              />
                            </div>
                          </div>

                          <div className="required field">
                            <label for="SecondInsurance">
                              {label.patient.add.secondInsurance}
                            </label>
                            <div className="inline fields ms-2 my-3">
                              <div className="ui radio checkbox">
                                <input
                                  type="radio"
                                  className="form-check-input"
                                  name="secondInsurance"
                                  value="1"
                                  onInputCapture={(e) => {
                                    e.preventDefault();
                                    setStateOfSecondInsurance(true);
                                    inputChange({
                                      target: {
                                        value: true,
                                        name: "secondInsurance",
                                      },
                                    });
                                  }}
                                />
                                <label className="form-check-label">
                                  {label.patient.add.yes}
                                </label>
                              </div>
                              <div className="ui radio checkbox ms-3">
                                <input
                                  type="radio"
                                  className="form-check-input"
                                  name="secondInsurance"
                                  value="0"
                                  onInputCapture={(e) => {
                                    e.preventDefault();
                                    setStateOfSecondInsurance(false);
                                    inputChange({
                                      target: {
                                        value: false,
                                        name: "secondInsurance",
                                      },
                                    });
                                  }}
                                />
                                <label className="form-check-label">
                                  {label.patient.add.no}
                                </label>
                              </div>
                            </div>
                          </div>

                          {
                            (stateOfSecondInsurance,
                            formData.secondInsurance && (
                              <div title="Primary Insurance">
                                <div
                                  className="tab-pane fade show active ui bottom attached"
                                  id="secondary"
                                  role="tabpanel"
                                  aria-labelledby="secondary-tab"
                                >
                                  <div className="two fields">
                                    <div className="required field">
                                      <label>
                                        {label.patient.add.insurancePartner}
                                      </label>
                                      <HPTSelect
                                        className="selection"
                                        options={insurancePartnerList}
                                        name="insurancePartnerId"
                                        getOptionLabel={(option) => option.name}
                                        getOptionValue={(option) => option.id}
                                        searchable={true}
                                        value={insurancePartnerList.find(
                                          (obj) =>
                                            obj.id ===
                                            formData.insuranceDetails[1]
                                              ?.insurancePartnerId
                                        )}
                                        onChange={(e) =>
                                          insuranceDetails2Change({
                                            target: {
                                              value: e.id,
                                              name: "insurancePartner",
                                            },
                                          })
                                        }
                                      />
                                    </div>
                                    <div className="required field">
                                      <label>
                                        {" "}
                                        {label.patient.add.policyNo}
                                      </label>
                                      <input
                                        type="text"
                                        placeholder={label.patient.add.policyNo}
                                        name="policyNo"
                                        value={
                                          formData?.insuranceDetails[1]
                                            ?.policyNo
                                        }
                                        onInputCapture={(e) => {
                                          e.preventDefault();
                                          insuranceDetails2Change(e);
                                        }}
                                      />
                                    </div>
                                  </div>
                                  <div className="two fields">
                                    <div className="field">
                                      <label>{label.patient.add.groupNo}</label>
                                      <input
                                        type="text"
                                        placeholder={label.patient.add.groupNo}
                                        name="groupNo2"
                                        value={
                                          formData?.insuranceDetails[1]
                                            ?.groupNo2
                                        }
                                        onInputCapture={(e) => {
                                          e.preventDefault();
                                          insuranceDetails2Change(e);
                                        }}
                                      />
                                    </div>
                                    <div className="field">
                                      <label>{label.patient.add.binNo}</label>
                                      <input
                                        type="text"
                                        placeholder="Bin No"
                                        name="binNo2"
                                        value={
                                          formData?.insuranceDetails[1]?.binNo2
                                        }
                                        onInputCapture={(e) => {
                                          e.preventDefault();
                                          insuranceDetails2Change(e);
                                        }}
                                      />
                                    </div>
                                  </div>
                                  <div className="two fields">
                                    <div className="required field">
                                      <label>
                                        {label.patient.add.relation}
                                      </label>
                                      <HPTSelect
                                        options={PatientEnum.RelationEnum}
                                        name="relation"
                                        getOptionLabel={(option) => option.type}
                                        getOptionValue={(option) =>
                                          option.value
                                        }
                                        searchable={true}
                                        value={PatientEnum.RelationEnum.find(
                                          (obj) =>
                                            obj.type ===
                                            formData?.insuranceDetails[1]
                                              ?.relation
                                        )}
                                        onChange={(e) =>
                                          insuranceDetails2Change({
                                            target: {
                                              value: e.value,
                                              name: "relation",
                                            },
                                          })
                                        }
                                      ></Select>
                                    </div>
                                  </div>
                                  <div className="two fields">
                                    {formData.Relation2 == 0 && (
                                      <div className="required field">
                                        <label>
                                          {" "}
                                          {label.patient.add.firstName}
                                        </label>
                                        <input
                                          placeholder="Subscriber First Name"
                                          type="text"
                                          name="firstName"
                                          value={
                                            formData?.insuranceDetails[1]
                                              ?.firstName
                                          }
                                          onChange={(e) => {
                                            e.preventDefault();
                                            insuranceDetails2Change(e);
                                          }}
                                        />
                                      </div>
                                    )}
                                    {formData.Relation2 != 0 && (
                                      <div className="required field">
                                        <label>
                                          {
                                            label.patient.add
                                              .subscriberFirstName
                                          }
                                        </label>
                                        <input
                                          placeholder="Subscriber First Name"
                                          type="text"
                                          name="firstName"
                                          value={
                                            formData?.insuranceDetails[1]
                                              ?.firstName
                                          }
                                          onChange={(e) => {
                                            e.preventDefault();
                                            insuranceDetails2Change(e);
                                          }}
                                        />
                                      </div>
                                    )}
                                    {formData.Relation2 == 0 && (
                                      <div className="required field">
                                        <label>
                                          {" "}
                                          {label.patient.add.lastName}
                                        </label>
                                        <input
                                          placeholder="Subscriber Last Name"
                                          type="text"
                                          name="lastName"
                                          value={
                                            formData?.insuranceDetails[1]
                                              ?.lastName
                                          }
                                          onChange={(e) => {
                                            e.preventDefault();
                                            insuranceDetails2Change(e);
                                          }}
                                        />
                                      </div>
                                    )}
                                    {formData.Relation2 != 0 && (
                                      <div className="required field">
                                        <label>
                                          {label.patient.add.subscriberLastName}
                                        </label>
                                        <input
                                          placeholder="Subscriber Last Name"
                                          type="text"
                                          name="lastName"
                                          value={
                                            formData?.insuranceDetails[1]
                                              ?.lastName
                                          }
                                          onChange={(e) => {
                                            e.preventDefault();
                                            insuranceDetails2Change(e);
                                          }}
                                        />
                                      </div>
                                    )}
                                  </div>
                                  <div className="two fields">
                                    <div className="required field">
                                      <label> {label.patient.add.phone}</label>
                                      <input
                                        placeholder="Phone"
                                        type="text"
                                        name="phone"
                                        mask="000-000-0000"
                                        unmask={true}
                                        value={
                                          formData?.insuranceDetails[1]?.phone
                                        }
                                        validation="false"
                                        onChange={(e) => {
                                          e.preventDefault();
                                          insuranceDetails2Change(e);
                                        }}
                                      />
                                    </div>
                                    <div className="field">
                                      <label> {label.patient.add.email}</label>
                                      <input
                                        placeholder="Email"
                                        type="text"
                                        name="insureEmail2"
                                        value={
                                          formData?.insuranceDetails[1]
                                            ?.insureEmail2
                                        }
                                        onInputCapture={(e) => {
                                          e.preventDefault();
                                          insuranceDetails2Change(e);
                                        }}
                                      />
                                    </div>
                                  </div>
                                  <div className="field ui checkbox">
                                    <input
                                      type="checkbox"
                                      className="form-check-input"
                                      name="sameAsPatientAddress2"
                                      value={
                                        formData?.insuranceDetails[1]
                                          ?.samePatientAddress2 === "true"
                                          ? true
                                          : false
                                      }
                                      onInputCapture={(e) => {
                                        let newData = e;
                                        newData.target.value =
                                          newData.target.checked;
                                        console.log(e);
                                        e.preventDefault();
                                        insuranceDetails2Change(newData);
                                        setSameAddress2(true);
                                      }}
                                    />
                                    <label className="form-check-label">
                                      {label.patient.add.sameAsInsurerAddress}
                                    </label>
                                  </div>
                                  <div className="field">
                                    <label>
                                      {label.patient.add.addressLine1}
                                    </label>
                                    <input
                                      placeholder="Address Line 1"
                                      type="text"
                                      name="secInsureAddressLine1"
                                      value={
                                        formData?.insuranceDetails[1]
                                          ?.secInsureAddressLine1
                                      }
                                      onChange={(e) => {
                                        e.preventDefault();
                                        insuranceAddressDetails2Change(e);
                                      }}
                                      disabled={
                                        formData?.insuranceDetails[1]
                                          ?.sameAsPatientAddress2 === "true"
                                          ? true
                                          : null
                                      }
                                    />
                                  </div>
                                  <div className="field">
                                    <label>
                                      {label.patient.add.addressLine2}
                                    </label>
                                    <input
                                      placeholder="Address Line 2"
                                      type="text"
                                      name="secInsureAddressLine2"
                                      value={
                                        formData?.insuranceDetails[1]
                                          ?.secInsureAddressLine2
                                      }
                                      onChange={(e) => {
                                        e.preventDefault();
                                        insuranceAddressDetails2Change(e);
                                      }}
                                      disabled={
                                        formData?.insuranceDetails[1]
                                          ?.sameAsPatientAddress2 === "true"
                                          ? true
                                          : null
                                      }
                                    />
                                  </div>
                                  <div className="two fields">
                                    <div className="field">
                                      <label>{label.patient.add.city}</label>
                                      <input
                                        placeholder="City"
                                        type="text"
                                        name="insureCity2"
                                        value={
                                          formData?.insuranceDetails[1]
                                            ?.insureCity2
                                        }
                                        onChange={(e) => {
                                          e.preventDefault();
                                          insuranceAddressDetails2Change(e);
                                        }}
                                        disabled={
                                          formData?.insuranceDetails[1]
                                            ?.sameAsPatientAddress2
                                            ? true
                                            : null
                                        }
                                      />
                                    </div>
                                    <div className="field">
                                      <label>{label.patient.add.country}</label>
                                      <HPTSelect
                                        className="selection"
                                        options={Countries}
                                        name="insureCountry2"
                                        value={Countries.find(
                                          (obj) =>
                                            obj.name ===
                                            formData?.insuranceDetails[1]
                                              ?.insureCountry
                                        )}
                                        onChange={(e) => {
                                          insuranceAddressDetails2Change({
                                            target: {
                                              value: e.name,
                                              name: "insureCountry",
                                            },
                                          });
                                        }}
                                        getOptionLabel={(option) => option.name}
                                        getOptionValue={(option) =>
                                          option.countryId
                                        }
                                        InsureCountry2
                                        disabled={
                                          formData?.insuranceDetails[1]
                                            ?.sameAsPatientAddress2
                                            ? true
                                            : null
                                        }
                                      >
                                        <div className="ui icon search input">
                                          <i className="search icon"></i>
                                        </div>
                                        <div className="divider"></div>
                                      </Select>{" "}
                                    </div>
                                  </div>
                                  <div className="two fields">
                                    <div className="field">
                                      <label>{label.patient.add.state}</label>
                                      <HPTSelect
                                        className="selection"
                                        options={
                                          formData?.insuranceDetails[1]
                                            ?.insureCountry === "CANADA"
                                            ? States[2]
                                            : States[1]
                                        }
                                        name="insureState2"
                                        value={
                                          formData?.insuranceDetails[1]
                                            ?.insureCountry === "CANADA"
                                            ? States[2].find(
                                                (obj) =>
                                                  obj.abbreviation ===
                                                  formData?.insuranceDetails[1]
                                                    ?.insureState2
                                              )
                                            : States[1].find(
                                                (obj) =>
                                                  obj.abbreviation ===
                                                  formData?.insuranceDetails[1]
                                                    ?.insureState2
                                              )
                                        }
                                        onChange={(e) => {
                                          insuranceDetails2Change({
                                            target: {
                                              value: e.abbreviation,
                                              name: "state",
                                            },
                                          });
                                        }}
                                        getOptionLabel={(option) => option.name}
                                        getOptionValue={(option) =>
                                          option.abbreviation
                                        }
                                        onChange={(e) => {
                                          // e.preventDefault();
                                        }}
                                        disabled={
                                          formData?.insuranceDetails[1]
                                            ?.sameAsPatientAddress2 === "true"
                                            ? true
                                            : null
                                        }
                                      />
                                      <div className="ui icon search input">
                                        <i className="search icon"></i>
                                      </div>
                                      <div className="divider"></div>{" "}
                                    </div>
                                    <div className="field">
                                      <label>
                                        {" "}
                                        {label.patient.add.postalCode}
                                      </label>
                                      <input
                                        placeholder="Postal (Zip) Code"
                                        type="text"
                                        mask="00000-0000"
                                        unmask={true}
                                        validation="false"
                                        name="insurePostalCode2"
                                        value={
                                          formData?.insuranceDetails[1]
                                            ?.insurePostalCode2
                                        }
                                        onChange={(e) => {
                                          e.preventDefault();
                                          insuranceDetails2Change(e);
                                        }}
                                        disabled={
                                          formData?.insuranceDetails[1]
                                            ?.sameAsPatientAddress2 === "true"
                                            ? true
                                            : null
                                        }
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ))
                          }
                        </div>
                      </div>
                    </TabsTemplate>
                  </div>
                ))
              }
            </div>
          </div> */}

          <div title="Tags">
            <div className=" row d-flex align-items-start">
              <div className="col-md-6 col-12 field">
                <label>{label.patient.add.patientTag}</label>
                {formData.patientTags && formData.patientTags.map((tag, i) => {
                  return (
                    <div className="chipX transition visible ui label mb-2" key={i}>
                      <span>{tag.name}</span>
                      <span className="prodtg-close" onClick={i => removeTag(i)}>&nbsp;<i className="close icon"></i></span>
                    </div>
                  );
                })}
                <HPTSelect
                  options={tagsList}
                  className="react-select-container"
                  classNamePrefix="react-select"
                  //name="patientTagId"
                  value=""
                  onChange={e => {
                    tagsHandler(e)
                  }}
                  getOptionLabel={(option) => option.name}
                  getOptionValue={(option) => option.patientTagId}
                  // menuPortalTarget={document.body}
                  // styles={{menuPortal: base => ({ ...base, zIndex: 9999 }),}}
                />
              </div>
            </div>
          </div>
        </AccordionTemplate>
      <div className="mt-3 d-flex justify-content-between modal-button-bar">
        
        <div className="col-auto">
          <button
            className="btn btn-primary"
            onClick={(e) => {
              e.preventDefault();
              if (!FormValidatorService.checkForm(errors, formData, required)) {
                toast.error("Please make sure the form is complete")
              }
              else {
                if(formData.email === "" && formData.phone === ""){
                  setShowConfirm(true) 
                }else{
                  props.submitHandler(formData);
                }
                
              }
              // validateEmail(e)
            }}
          >
            {submitLabel}
          </button>
        </div>
        <div className="col-auto">
          {props.isModal && <button
            className="btn btn-secondary"
            onClick={(e) => {
              e.preventDefault();
              if (props.onClose()) {
                props.onClose();
              }
            }}
          >
            Close
          </button>}
        </div>
      </div>
      <ModalBox open={showConfirm} onClose={() => { setShowConfirm(false) }} onCloseSuccess={() => { setShowConfirm(false); props.submitHandler(formData) }} title="Confirm" confirmButton="Yes" cancelButton="Cancel">
        <span>Warning: Removing contact information will disable the patient's access to the patient portal and stop transaction updates. Are you sure you want to continue?</span>
      </ModalBox>
    </>
  );
};
export default PatientForm;
